import { forwardRef } from "react";
import Dropdown from "react-bootstrap/Dropdown";

import T from "../translations/Translations";

/* eslint-disable */
/**
 * A dropdown menu displaying resource links for the guardian
 * @name HelpfulLinks
 * @returns {JSX.Element}
 */
const HelpfulLinks = () => {
    /**
     * The forwardRef is important!!
     * Dropdown needs access to the DOM node in order to position the Menu
     * @name helpfulToggle
     * @param {{node|func}} {children, onClick}
     * @param {node} ref
     * @return {JSX.Element}
     */
    const helpfulToggle = forwardRef(({ children, onClick }, ref) => (
        <button
            aria-label="Helpful Links Button"
            className="btn btn-primary m-2 color-override"
            onClick={(e) => {
                e.preventDefault();
                onClick(e);
            }}
            ref={ref}
            style={{ minWidth: "160px" }}
            type="button"
        >
            <span className="nav-button-text">
                {T({ key: "Main_Nav_HelpfulLinks" })}
                <i className="bi bi-info-square" style={{ fontSize: "0.9rem", fontWeight: 700, marginLeft: "10px" }} />
            </span>
        </button>
    ));

    return (
        <Dropdown align="end">
            <Dropdown.Toggle as={helpfulToggle} id="dropdown-custom-components">
                <b>{T({ key: "Main_Nav_LogOut" })}</b>
            </Dropdown.Toggle>
            <Dropdown.Menu>
                <Dropdown.Item href="https://www.dcsdk12.org/schools-academics/academic-calendars" target="_blank">
                    {/* Academic Calendars */}
                    <i className="bi bi-calendar2-week" /> {T({ key: "Main_Nav_HelpfulLinks_LI_s2" })}
                </Dropdown.Item>
                <Dropdown.Item
                    href="https://www.dcsdk12.org/about/departments/transportation/bus-routes"
                    target="_blank"
                >
                    {/* Bus Routes */}
                    <i className="bi bi-bus-front" /> {T({ key: "Main_Nav_HelpfulLinks_LI_s4" })}
                </Dropdown.Item>
                <Dropdown.Item href="https://dcsd.nutrislice.com/menus-eula" target="_blank">
                    {/* Lunch Menus */}
                    <i className="bi bi-apple" /> {T({ key: "Main_Nav_HelpfulLinks_LI_s6" })}
                </Dropdown.Item>
                <Dropdown.Item href="https://www.myschoolbucks.com/ver2/getmain?requestAction=home" target="_blank">
                    {/* Online Payments */}
                    <i className="bi bi-coin" /> {T({ key: "Main_Nav_HelpfulLinks_LI_s5" })}
                </Dropdown.Item>
                <Dropdown.Item href="https://www.dcsdk12.org/parents-students/resources" target="_blank">
                    {/* Parent Resources */}
                    <i className="bi bi-journals" /> {T({ key: "Main_Nav_HelpfulLinks_LI_s3" })}
                </Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    );
};
/* eslint-enable */

export default HelpfulLinks;
